export { default } from '../../sub/mobile-responsive';

